import { IApiService } from '../services/ApiService';
import { LoaderFunctionArgs, redirect } from 'react-router';
import { authNavigationService } from '../services/AuthNavigationService';
import { Logger } from '../utils/Logger';

export function mainLayoutLoader(apiService: IApiService) {
  return async ({ request }: LoaderFunctionArgs) => {
    const pathname = new URL(request.url).pathname;
    const isPublicRoute = authNavigationService.isPublicRoute(pathname);

    Logger.debug('LOADER', `mainRoute loader starting - pathname: ${pathname}, isPublicRoute: ${isPublicRoute}`);

    // Check authentication state from apiService
    // Note: isAuthenticated() returns cached state, no API call needed
    const isAuthenticated = apiService.isAuthenticated();
    Logger.debug('LOADER', "mainRoute loader - isAuthenticated:", isAuthenticated);

    // Authenticated user trying to access public route → redirect to /
    if (isAuthenticated && isPublicRoute) {
      const redirectUrl = authNavigationService.getRedirectUrlForAuthenticatedOnPublic(pathname);
      if (redirectUrl) {
        Logger.debug('LOADER', `Authenticated user on public route, redirecting to: ${redirectUrl}`);
        return redirect(redirectUrl);
      }
    }

    // Non-authenticated user trying to access protected route → redirect to login with returnUrl
    if (!isAuthenticated && !isPublicRoute) {
      const returnUrl = pathname;
      const loginUrl = `/account/login?returnUrl=${encodeURIComponent(returnUrl)}`;
      Logger.debug('LOADER', `Non-authenticated user on protected route, redirecting to: ${loginUrl}`);
      return redirect(loginUrl);
    }

    // Return loader data
    // Note: userDetail is now loaded by individual pages that need it (like HomePage, MePage)
    return { isAuthenticated, isPublicRoute };
  };
}
